import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import * as COLORS from '../../../constants/colors'

export const Quote = styled(function Quote(props: SpecificIconProps): React.ReactElement<SpecificIconProps> {
  return (
    <Icon {...props} viewBox="0 0 14 15" name="quote">
      <g fill={COLORS.PRIMARY_RED_500}>
        <path d="m7.5582 12.27c0.28888 0.3176 0.42788 0.7437 0.40205 1.1709-0.01343 0.222-0.07262 0.4441-0.17657 0.6489-0.30505 0.6047-0.91091 0.8874-1.5071 0.7075l-5.1266-1.5427c-0.40456-0.1205-0.7299-0.4409-0.8897-0.8755-0.15986-0.4347-0.13352-0.9201 0.074066-1.3264l1.3395-2.6257c0.20759-0.40624 0.56267-0.67747 0.97532-0.74176 0.4127-0.06411 0.82147 0.08751 1.1189 0.41607l3.7902 4.1687z" />
        <path d="m11.464 1.1929 2.0188 5.5117c0.0809 0.22605 0.1157 0.45884 0.102 0.68426-0.0254 0.42002-0.2111 0.81793-0.5295 1.0884-0.4921 0.41863-1.1476 0.41261-1.6341-0.01975l-4.1725-3.6972c-0.33028-0.28963-0.51421-0.72946-0.51016-1.1997 0.00423-0.47326 0.20113-0.90432 0.53538-1.1845l2.1539-1.8178c0.33422-0.27958 0.75466-0.37096 1.156-0.24706 0.4011 0.12692 0.7204 0.44728 0.8802 0.8816z" />
      </g>
    </Icon>
  )
})``
